import axios from "axios";

// const BASE_URL = "https://app-dev.x.tgn.mk/api/";
const BASE_URL = "/api/";

class ApiMethods {
  static async apiRequest(method, url, data = {}, token = null) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      const response = await axios({
        method,
        url: `${BASE_URL}${url}`,
        data: method !== "GET" ? data : null,
        headers,
      });

      // Any 2xx is a success per HTTP — not just 200. Endpoints that create a
      // resource correctly reply 201 (e.g. client-packages/create, addClient),
      // and checking `== 200` silently dropped their response body, so callers
      // that immediately used the returned row (e.g. to update a cache) always
      // got `undefined` even though the save itself succeeded.
      if (response.status >= 200 && response.status < 300) {
        return response.data;
      }
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  static get(url, token = null) {
    return this.apiRequest("GET", url, {}, token);
  }

  static post(url, data, token = null) {
    return this.apiRequest("POST", url, data, token);
  }

  static put(url, data, token = null) {
    return this.apiRequest("PUT", url, data, token);
  }

  static delete(url, token = null) {
    return this.apiRequest("DELETE", url, {}, token);
  }

  // File uploads (multipart) — apiRequest()/post() always force
  // Content-Type: application/json, which breaks a FormData body's multipart
  // boundary. This omits that header so axios can set its own
  // "multipart/form-data; boundary=..." automatically.
  static async postFormData(url, formData, token = null) {
    try {
      const headers = {};
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }
      const response = await axios.post(`${BASE_URL}${url}`, formData, {
        headers,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
}

export default ApiMethods;
